import React from 'react';

const Index = React.lazy(() => import('../page/index'));
const Detail = React.lazy(() => import('../page/detail/detail'));
const Category = React.lazy(() => import('../page/detail/category.js'));
const ShoppingCart = React.lazy(() => import('../page/shoppingCart'));
const FillBill = React.lazy(() => import('../page/shoppingCart/fillBill'));
const MyBill = React.lazy(() => import('../page/mybill'));
const GetStageProperty = React.lazy(() => import('../page/mybill/getStageProperty'));
const ShowPayFrame = React.lazy(() => import('../page/shoppingCart/showPayFrame'));
const OrderInfoDemo = React.lazy(() => import('../page/shoppingCart/orderInfoDemo'));
const ScAgreement = React.lazy(() => import('../page/agreement'));
const Lottery = React.lazy(() =>import('../page/lottery'));
const ExchangeItems = React.lazy(() => import('../page/mybill/exchangeItems'));
const Ssykh = React.lazy(() => import('../page/ssykh'));
const CardQuery = React.lazy(() => import('../page/mybill/cardQuery'));
const ProductDetails = React.lazy(() => import('../page/ProductDetails'));

const route = [
    { path: '/', exact: true, name: 'Index', component: Index },
    { path: '/detail/1', exact: true, name: 'Detail', component: Detail },
    { path: '/commodity/category/2', exact: true, name: 'Other', component: Category },
    { path: '/shoppingCart', exact: true, name: 'ShoppingCart', component: ShoppingCart },
    { path: '/fillBill', exact: true, name: 'FillBill', component: FillBill },
    { path: '/myBill', exact: true, name: 'myBill', component: MyBill }, // 我的订单页
    { path: '/getStageProperty', exact: true, name: 'GetStageProperty', component: GetStageProperty }, // 领取游戏内道具
    { path: '/showPayFrame', exact: true, name: 'ShowPayFrame', component: ShowPayFrame },
    { path: '/orderInfoDemo', exact: true, name: 'OrderInfoDemo', component: OrderInfoDemo },
    { path: '/agreement', exact: true, name: 'ScAgreement', component: ScAgreement },//商城周边协议
    { path: '/exchangeItems', exact: true, name: 'ExchangeItems', component: ExchangeItems },//兑换道具
    { path: '/lottery',exact:true,name:'Lottery',component:Lottery},//抽奖页面
    { path: '/ssykh',exact:true,name:'Ssykh',component:Ssykh},//双十一狂欢活动
    { path: '/cardQuery',exact:true,name:'CardQuery',component:CardQuery},//兑换卡查询
    { path: '/productDetails',exact:true,name:'ProductDetails',component:ProductDetails}//二十周年典藏礼盒
]
export default route;
